// @flow
import { createContext } from 'react';

import { getCurrentBreakpoint } from './Responsive.helper';
import getResponsiveProps from './getCurrentResponsive';

const ResponsiveContext = createContext<ResponsiveProps>(
  getResponsiveProps({ currentBreakpoint: getCurrentBreakpoint('', false), isAppMounted: false }),
);

export default ResponsiveContext;
